export default __webpack_public_path__ + "static/NGSwv5HMAFg6IuGlBNMjxLsL8ahuQ2e8Smg-14cf6e7a322789501c43300294fa0bb9.woff2";